"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addClassName = addClassName;
exports.addClassInPropsKey = addClassInPropsKey;
exports.addClassByPropName = addClassByPropName;
exports.addClassByPropValue = addClassByPropValue;
exports.addDefaultCSS = addDefaultCSS;

var _types = require("./types");

function addClassName() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var className = arguments.length > 1 ? arguments[1] : undefined;

  if (className && !names.some(function (n) {
    return n === className;
  })) {
    names.push(className);
  }
}

function addClassInPropsKey() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var classNameKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'className';

  if (props && (0, _types.objHasKeys)(props)) {
    if ((0, _types.objHasOwnProperty)(props, classNameKey)) {
      var className = props[classNameKey];

      if (className) {
        var splittedNames = className.split(' ');

        if ((0, _types.arrayHasItems)(splittedNames)) {
          splittedNames.forEach(function (n) {
            addClassName(names, n);
          });
        }
      }
    }
  }
}

function addClassByPropName() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var classNameKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'className';

  if (props && (0, _types.objHasKeys)(props)) {
    var onClick = props.onClick;

    if ((0, _types.objHasOwnProperty)(props, classNameKey)) {
      var className = props[classNameKey]; // TODO: move className as another function
      // add className

      if (className) {
        var splittedNames = className.split(' ');

        if ((0, _types.arrayHasItems)(splittedNames)) {
          splittedNames.forEach(function (n) {
            addClassName(names, n);
          });
        }
      }
    } // add onClick


    if (onClick) {
      addClassName(names, 'clickable');
    } // add prop's name


    if ((0, _types.arrayHasItems)(keys)) {
      keys.forEach(function (k) {
        if (props[k]) {
          addClassName(names, k);
        }
      });
    }
  }
}

function addClassByPropValue() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (props && (0, _types.objHasKeys)(props)) {
    // add props's value
    if ((0, _types.arrayHasItems)(keys)) {
      keys.forEach(function (k) {
        addClassName(names, props[k]);
      });
    }
  }
}

function addDefaultCSS() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  addClassName(names, 'MHub-Default');
}